<script>
import { layoutComputed } from "@/state/helpers";
import Horizontal from "./horizontal";

export default {
  components: { /*Vertical ,*/ Horizontal },
  computed: {
    ...layoutComputed
  },
};
</script>



<template>
  <div>
    <!-- <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
      <slot />
    </Vertical> -->
    <Horizontal v-if="layoutType === 'vertical'" :layout="layoutType" class="zoom-container">

      <slot />
    </Horizontal>
  </div>
</template>

<style >

  @media screen and (max-width: 1400px) {
    .tmp-hide {
        display: none ;
    } 
  }

  @media screen and (min-width: 1390px) {
    .zoom-container {
        zoom: 100%;
    } 
  }

  @media screen and (max-width: 1390px) {
    .zoom-container {
      zoom: 75%;
    } 
    /* Cart FIXES */
    .zoom-container #sidebar-backdrop{
      height: 100% !important;
    }
    .b-sidebar-backdrop{
      width: 100% !important;
      height: 100% !important;
    }
    .item-details-medium{
      zoom: 90% !important;
    }

  }

  @media screen and (max-width: 800px) {
    .zoom-container {
      zoom: 60%;
    }
    .item-details-medium{
      zoom: 100% !important;
    }
  } 

  @media screen and (max-width: 500px) {
    .zoom-container {
        zoom: 100%;
    } 
  }

  .wishes-container {
    /* background-image: url('~@/assets/images/wishes.jpg');  */
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    padding: 20px;
    color: #fff; 
    background-color: #fff;
}

@import url('https://fonts.googleapis.com/css2?family=Dancing+Script:wght@700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Merriweather:wght@800&display=swap');

@keyframes textAnimation {
      0%, 100% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.1);
        opacity: 0.8;
      }
    }

    .animated-text {
      letter-spacing: 2px;
      font-size: 35px;
      font-weight: 700;
      font-family: 'Dancing Script', cursive;
      font-style: italic;
      text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.5);
      animation: textAnimation 2s infinite; /* Adjust the duration as needed */
    }




</style>
